import { getCoreDataSecurityActionTemplatesSlice } from './get';
import { postCoreDataSecurityActionTemplateSlice } from './post';

export * from './_id/actions';
export * from './_url/actions';

export const { requestGetCoreDataSecurityActionTemplates, resetGetCoreDataSecurityActionTemplates } =
	getCoreDataSecurityActionTemplatesSlice.asyncActionCreators;

export const { requestPostCoreDataSecurityActionTemplate, resetPostCoreDataSecurityActionTemplate } =
	postCoreDataSecurityActionTemplateSlice.asyncActionCreators;
